import { HTMLAttributes } from 'react'
import { map } from 'lodash'
import Link from 'next/link'

import Typography from './typography'
import { cn } from '@/lib/utils'
import { WPPageData } from '@/types'

export type BreadcrumbProp = HTMLAttributes<HTMLDivElement>

export const Breadcrumb = ({ children, ...props }: BreadcrumbProp) => {
  return (
    <Typography variant="breadcrumbs" {...props}>
      {children}
    </Typography>
  )
}

export type BreadcrumbProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    schema: WPPageData['breadcrumbs']
  }>

const Breadcrumbs = ({ schema = [], className, ...props }: BreadcrumbProps) => {
  return (
    <div className={cn(className)} {...props}>
      {map(schema, ({ title, url }, index) => (
        <span key={`breadcrumb-${index}`}>
          {index < schema?.length - 1 ? (
            <Link href={url} scroll={false} className="focus-ring-dark rounded-md">
              <Breadcrumb>{title}</Breadcrumb>
            </Link>
          ) : (
            <Breadcrumb>{title}</Breadcrumb>
          )}
          {index < schema?.length - 1 ? <Breadcrumb>{` / `}</Breadcrumb> : null}
        </span>
      ))}
    </div>
  )
}

export default Breadcrumbs
